import type { InvariantJiraRoute } from '@jira/platform__routing-route-types/src/InvariantJiraRoute.tsx';

export const legacyJsdReportsCustomRoute: InvariantJiraRoute = {
	name: 'legacy-jsd-reports-custom',
	path: '/projects/:projectKey/reports/custom/:id?',
};
